/* tslint:disable */

import { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import 'assets/css/MiniCalendar.css';
import { Text, Icon, Button, FormLabel, useColorModeValue, Accordion , AccordionItem, AccordionButton, Box, AccordionIcon, AccordionPanel   } from '@chakra-ui/react';
// Chakra imports
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
// Custom components
import Card from 'components/card/Card';


import commonUtils from "utils/commonUtils"

export default function MiniCalendar(props: { selectRange: boolean; onChangeSelection: any; [x: string]: any }
	) {
		const textColorPrimary = useColorModeValue('gray.800', 'white');
	const { selectRange, ...rest } = props;
	const [ value, onChange ] = useState(new Date());
	const [ rangeText, setRangeText ] = useState('');
	const [ hiddenClear, setHiddenClear ] = useState(true);

	const handlerChangeCalendar = (temp) => {
		onChange(temp)
		if (temp !== undefined && temp !== null) {
			if (temp.length === 2){
				props.onChangeSelection({ fechaInicio: temp[0] , fechaFin: temp[1]})
				setRangeText(`${commonUtils.formatDate(temp[0])} al ${commonUtils.formatDate(temp[1])}`)
				setHiddenClear(false)
			}
			else if (temp.length === 1){
				props.onChangeSelection({ fechaInicio: temp[0], fechaFin: null })
				setRangeText(`${commonUtils.formatDate(temp[0])}`)
				setHiddenClear(false)
			}
			else{
				props.onChangeSelection({ fechaInicio: null, fechaFin: null })
				setRangeText('')
				setHiddenClear(true)
			}
		}
		else{
			setRangeText('')
			setHiddenClear(true)
		}
	};
	const clearSelection = () => {
		onChange(null)
		setRangeText('')
		setHiddenClear(true)
		props.onChangeSelection({ fechaInicio: null, fechaFin: null })
	};


	return (
		<Accordion allowToggle borderRadius='8px' borderWidth='1px'>
			<AccordionItem borderWidth='0px !important'>
    <h2 height='38px !important'>
      <AccordionButton>
        <Box as="span" flex='1' textAlign='left' color={textColorPrimary}>
		{rangeText}
        </Box>  
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel >
	<Card
			alignItems='center'
			flexDirection='column'
			w='100%'
			ml='7%'
			maxW='max-content'
			p='20px 15px'
			h='max-content'
			{...rest}><Button colorScheme='linkedin' size="sm" onClick={clearSelection} hidden={hiddenClear}>Limpiar selección</Button>
			<Calendar
				onChange={handlerChangeCalendar}
				value={value}
				selectRange={selectRange}
				view={'month'}
				allowPartialRange={true}
				minDate={new Date(2014, 1, 1)}
				maxDate={new Date()}
				locale='es-VE'
				tileContent={<Text color='brand.500' />}
				prevLabel={<Icon as={MdChevronLeft} w='24px' h='24px' mt='4px' />}
				nextLabel={<Icon as={MdChevronRight} w='24px' h='24px' mt='4px' />}
			/>
		</Card>
    </AccordionPanel>
  </AccordionItem>
		
		</Accordion>
	);
}
